import { Layout, Spin } from '@arco-design/web-react';
import styled from '@emotion/styled';
import { useAtom } from 'jotai';
import React, { Suspense, useState } from 'react';
import AppBar from './components/AppBar';
import { LayoutSider } from './components/LayoutSider';
import { collapsedAtom } from './store';
import { Outlet } from 'react-router-dom';
import { useAuth } from '@/providers/AuthProvider';
import { useUserInfo } from '@/api';
import { PageLoading } from '@/components';
import { OptModal } from './components/OptModal';
import { PageTabs } from './components/PageTabs';

const { Header, Content } = Layout;

const LayoutWrapper = styled(Layout)`
  height: 100vh;
  width: 100vw;
  background-color: var(--color-bg-1);
`;

const LayoutHeader = styled(Header)`
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  height: 60px;
  z-index: 100;

  &-hidden {
    height: 0;
  }
`;

export const BasicLayout = () => {
  const [collapsed] = useAtom(collapsedAtom);
  const { user } = useAuth();
  const [visible, setVisible] = useState(false);
  const { isLoading, isError } = useUserInfo({
    config: {
      onSuccess: (data) => {
        if (data.data.is_set_otp === 2) {
          setVisible(true);
        }
      },
    },
  });
  if (isLoading) {
    return <PageLoading />;
  }
  if (isError) {
    return null;
  }
  return (
    <LayoutWrapper hasSider>
      <OptModal visible={visible} onCancel={() => setVisible(false)} />
      {user && (
        <LayoutHeader>
          <AppBar />
        </LayoutHeader>
      )}
      <Layout>
        {user && <LayoutSider />}
        <Content
          className="bg-slate-100"
          style={{
            paddingTop: '56px',
            paddingLeft: collapsed ? '48px' : '220px',
            paddingRight: '0px',
            // background: '#fafafa',
          }}
        >
          <PageTabs />
          <div className="p-3.5">
            <Suspense fallback={<Spin delay={200} />}>
              <Outlet />
            </Suspense>
          </div>
        </Content>
      </Layout>
    </LayoutWrapper>
  );
};
